// redux/features/loginRecordSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import api from '@/axiosSetup';
import { IBCRRecord } from '../../../types/IBCRRecord';

interface BCRRecordState {
  records: IBCRRecord[];
  loading: boolean;
  error: string | null;
}

const initialState: BCRRecordState = {
  records: [],
  loading: false,
  error: null,
};

const bcrRecordSlice = createSlice({
  name: 'bcrRecords',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBCRRecords.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBCRRecords.fulfilled, (state, action: PayloadAction<IBCRRecord[]>) => {
        state.records = action.payload;
        state.loading = false;
      })
      .addCase(fetchBCRRecords.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const fetchBCRRecords = createAsyncThunk(
  'bcrRecords/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get<IBCRRecord[]>('/api/bcr-records');
      return res.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch bcr records');
    }
  }
);

export default bcrRecordSlice.reducer;
